import type { DashboardSchema, ProjectSchema } from '@shape-construction/api/src/types';
import type { Category } from '../types';

export const getCategoryFromRouteSegment = (segment: string): Category | undefined => {
  if (!segment) return undefined;
  const mapping: Record<string, Category> = {
    activities: 'activities',
    'change-tracker': 'change_tracker',
    channels: 'channels',
    'issue-tracker': 'issue_tracker',
    'shift-manager': 'shift_manager',
    custom: 'custom',
  };
  return mapping[segment] ?? 'shift_manager';
};

const categoryToRouteSegmentMapping: Record<Category, string> = {
  activities: 'activities',
  change_tracker: 'change-tracker',
  channels: 'channels',
  issue_tracker: 'issue-tracker',
  shift_manager: 'shift-manager',
  custom: 'custom',
};

export const getCategoryLink = (projectId: ProjectSchema['id'], category: Category) => {
  return `/projects/${projectId}/data-book/${categoryToRouteSegmentMapping[category]}`;
};

export const getDashboardLink = (projectId: ProjectSchema['id'], dashboard: DashboardSchema) => {
  return `${getCategoryLink(projectId, dashboard.category)}/${dashboard.id}`;
};
